export const createCETYear = () => {
  const date = new Date();
  date.setHours(date.getHours() + 1);

  const ISODate = date.toISOString();
  return new Date(ISODate).getFullYear();
};

export default {};
